import React from 'react';
import type { Group } from '@/types/group';

interface MenuItemProps {
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
}

interface GroupMenuOptionsProps {
  group: Group;
  onEditName: (group: Group) => void;
  onEditMembers: (group: Group) => void;
  onDeleteGroup?: (group: Group) => void;
  onActionComplete?: () => void;
  disableDelete?: boolean;
  MenuItem: React.ComponentType<MenuItemProps>;
  MenuSeparator: React.ComponentType<Record<string, never>>;
}

export function GroupMenuOptions({
  group,
  onEditName,
  onEditMembers,
  onDeleteGroup,
  onActionComplete,
  disableDelete = false,
  MenuItem,
  MenuSeparator,
}: GroupMenuOptionsProps) {
  const handleEditName = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEditName(group);
    onActionComplete?.();
  };

  const handleEditMembers = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEditMembers(group);
    onActionComplete?.();
  };

  const handleDeleteGroup = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDeleteGroup?.(group);
    onActionComplete?.();
  };

  return (
    <>
      <MenuItem onClick={handleEditName}>Edit name</MenuItem>
      <MenuItem onClick={handleEditMembers}>Edit members</MenuItem>
      <MenuSeparator />
      <MenuItem
        onClick={handleDeleteGroup}
        disabled={disableDelete}
        className={
          disableDelete ? '' : 'text-destructive focus:text-destructive'
        }
      >
        {disableDelete ? 'Deletion proposed' : 'Delete group'}
      </MenuItem>
    </>
  );
}
